import { Box, BoxProps, useTheme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { Location } from "@/icons/outlined";

export const FormLocationIconSquare = ({ sx, ...rest }: BoxProps) => {
  const theme = useTheme();

  const styles = mergeSx(
    {
      width: { xs: "38px", md: "46px" },
      height: { xs: "38px", md: "46px" },
      borderRadius: theme.radius(1),
      backgroundColor: "formsComponents.location.iconBackgroundColor",
      border: `1px solid ${theme.palette.formsComponents.location.iconBorderColor}`,
    },
    sx
  );

  return (
    <Box display="flex" alignItems="center" justifyContent="center" {...rest} sx={styles}>
      <FormIcon
        color={theme.palette.formsComponents.location.iconColor}
        sx={{ width: { xs: "24px", md: "28px" }, height: { xs: "24px", md: "28px" } }}
      >
        <Location />
      </FormIcon>
    </Box>
  );
};
